import React, { createContext } from "react";

export interface IInteractionContext {
    isProEnabled: boolean;
    setProEnable: (value: boolean) => void;
    isQuickCartVisible: boolean;
    setQuickCartVisible: React.Dispatch<React.SetStateAction<boolean>>;
}

export const InteractionContext = createContext<IInteractionContext>({
    isProEnabled: false,
    setProEnable: (value: boolean) => {},
    isQuickCartVisible: false,
    setQuickCartVisible: () => {},
});
